export default "__VITE_ASSET__BUKL0O4X__"